 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"default": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-00457291":"84125eed","chunk-04a5ec50":"efdedea5","chunk-08b4e8d8":"6094f364","chunk-0bdd084b":"45344c59","chunk-10a7f104":"a18e84a2","chunk-2d0a349d":"238cda01","chunk-2d0a4782":"94015a5d","chunk-2d0ab179":"7b9a34d8","chunk-2d0ab2e8":"ee6641ad","chunk-2d0aed06":"b85badb3","chunk-2d0aed1a":"74aa68ad","chunk-2d0aed56":"0443d070","chunk-2d0b310a":"cde780ce","chunk-2d0b3a46":"20f63b00","chunk-2d0b5a21":"5fe2ff4a","chunk-2d0b9231":"1a650805","chunk-2d0b9445":"d0d3a5ff","chunk-2d0ba933":"46843e9e","chunk-2d0bb21c":"3a1ba0e9","chunk-2d0bb21e":"28adb68a","chunk-2d0bd1ac":"3b18d183","chunk-2d0bff5f":"5b015d93","chunk-2d0c0c47":"cfc1b77f","chunk-2d0c1b2a":"6344a8c5","chunk-2d0c5226":"860e8446","chunk-2d0c73db":"6e6df262","chunk-2d0c7ab6":"8db37a99","chunk-2d0c89b7":"02aa8876","chunk-2d0c89dc":"cecd56d2","chunk-2d0c8a75":"67e24f39","chunk-2d0c91e8":"3b357c18","chunk-2d0c973c":"7cdea03c","chunk-2d0ced3f":"6899b30e","chunk-2d0ceded":"ba680d32","chunk-2d0cf73e":"5eafeebf","chunk-2d0d017c":"3ac9a47b","chunk-2d0d3500":"014a1724","chunk-2d0d6312":"6055f828","chunk-2d0d7465":"48bf1ac2","chunk-2d0d7666":"40df0be2","chunk-2d0d8054":"d7f14c6a","chunk-2d0d8389":"39030414","chunk-2d0da727":"916ce7e3","chunk-2d0da79e":"11a57372","chunk-2d0db304":"02c0e431","chunk-2d0dd7d3":"c4030d66","chunk-2d0de3a2":"f77a55ae","chunk-2d0e1794":"acf4d1ba","chunk-2d0e5061":"5ad100be","chunk-2d0e521c":"a81a6dd3","chunk-2d0e9d30":"a43e99b0","chunk-2d0e9d43":"1eb02901","chunk-2d0efc46":"bb0e798e","chunk-2d207769":"b5cb4cf5","chunk-2d207ba3":"bfec70d3","chunk-2d207bb6":"dde76cf0","chunk-2d20ef82":"c23624d3","chunk-2d20f776":"2c624817","chunk-2d213ebb":"a79fe763","chunk-2d215fa7":"30102850","chunk-2d2169a9":"62d409a6","chunk-2d219fb5":"dcab81db","chunk-2d21b109":"8fe6032c","chunk-2d21b8a7":"cab30e66","chunk-2d21d16f":"90c2e8bc","chunk-2d221453":"133fbed2","chunk-2d221dd6":"92396799","chunk-2d222525":"4f9d39ac","chunk-2d225fd3":"2fee7b40","chunk-2d22c6a5":"d210533a","chunk-2d22c6b5":"0ab81fa3","chunk-2d22cbf9":"5d0a3d4c","chunk-2d230311":"32f56801","chunk-2d2306de":"439f9c9c","chunk-2d230f8b":"51ecd525","chunk-2d230fa9":"5742ebd8","chunk-2d237923":"65d21e67","chunk-2e04583a":"99a7ae6e","chunk-32afa51b":"cf4d130e","chunk-36fae185":"f09341a8","chunk-3e2ae108":"c007aa4c","chunk-46d61d12":"641b1f3c","chunk-52dbf27c":"5bb09ed9","chunk-5a3e733e":"7c80a621","chunk-5d5e5bb2":"31bbad40","chunk-6c495737":"1d920724","chunk-6cfa55f6":"728c0102","chunk-6ed74c07":"74adae9a","chunk-7a187066":"a3e6af2b","chunk-7af7e620":"7a5b264c","chunk-7e39cbfa":"f454d06e","chunk-b2fcfd12":"be67cb62","chunk-b327c778":"de170640","chunk-b32a055c":"0d938ba7","chunk-b9d0417a":"01d6855b","chunk-d57d09dc":"572149df","chunk-df89f114":"52b591f1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/api/platform-web-assets/public/latest/partner-profile/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_partner-profile"] = window["webpackJsonp_partner-profile"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([4,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
